import React from 'react';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import TpEvaluatorLinkAdmin from '../Contents/ThirdParty/TpEvaluator/TpEvaluatorLinkAdmin';
import LinkedTpEvaluatorsTab from '../Contents/ThirdParty/TpEvaluator/LinkedTpEvaluatorsTab.tsx';
import dateTimeHelper from '../Helpers/datetimeHelper';
import FaIcon from '../Elements/FaIcon.js';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu.jsx';
import LongText from '../Elements/LongText.js';
import DateComponent from '../Elements/DateComponent.js';
import GeneralEntryLogFigma from '../Elements/GeneralEntryLog/GeneralEntryLogFigma';
import CommentsEntryLogDescription from '../Elements/CommentsEntryLogDescription';

export default class TpEvaluatorItem {
  constructor(item) {
    if (item == null) {
      this.TpEvaluatorId = 0;
      this.PrimaryTpEvaluatorId = null;
      this.CreatedOnUtc = null;
      this.ModifiedOnUtc = null;
      this.CreatedBy = 0;
      this.ModifiedBy = 0;
      this.EvaluatorId = null;
      this.ThirdPartySources = '';
      this.DataProviderInstance = '';
      this.Name = '';
      this.Email = '';
      this.Statuses = '';
      this.NumberOfTpEvaluatorLinks = '';
      this.Countries = '';
      this.TipaltiPayableStatus = '';
      this.TipaltiAccountStatus = '';
      this.TipaltiPaymentMethod = '';
      this.TipaltiPortalUser = '';
      this.LastTransferToTipalti = '';
      this.TipaltiAttemptedPassOver = '';
      this.TipaltiLastDataCheck = '';
      this.TipaltiError = '';
      this.EvaluatorSassieId = '';
      this.TipaltiId = '';
      this.AttachedTpEvaluators = [];
      return;
    }
    this.TpEvaluatorId = item.tpEvaluatorId;
    this.PrimaryTpEvaluatorId = item.primaryTpEvaluatorId;
    this.CreatedOnUtc = item.createdOnUtc;
    this.ModifiedOnUtc = item.modifiedOnUtc;
    this.CreatedBy = item.createdBy;
    this.ModifiedBy = item.modifiedBy;
    this.EvaluatorId = item.evaluatorId;
    this.ThirdPartySources = item.thirdPartySources;
    this.DataProviderInstance = item.dataProviderInstance;
    this.Name = item.name;
    this.Email = item.email;
    this.Statuses = item.statuses;
    this.NumberOfTpEvaluatorLinks = item.numberOfTpEvaluatorLinks;
    this.Countries = item.countries;
    this.TipaltiPayableStatus = item.tipaltiPayableStatus;
    this.TipaltiAccountStatus = item.tipaltiAccountStatus;
    this.TipaltiPaymentMethod = item.tipaltiPaymentMethod;
    this.TipaltiPortalUser = item.tipaltiPortalUser;
    this.LastTransferToTipalti = item.lastTransferToTipalti;
    this.TipaltiAttemptedPassOver = item.tipaltiAttemptedPassOver;
    this.TipaltiLastDataCheck = item.tipaltiLastDataCheck;
    this.TipaltiError = item.tipaltiError;
    this.EvaluatorSassieId = item.evSassieId;
    this.TipaltiId = item.tipaltiId;
    // CD-5527: the profiles linked under this one (children never appear as rows of the main list).
    this.AttachedTpEvaluators = (item.attachedTpEvaluators ?? []).map((child) => new TpEvaluatorItem(child));
  }

  static hasAttachedTpEvaluators(item) {
    return Array.isArray(item.AttachedTpEvaluators) && item.AttachedTpEvaluators.length > 0;
  }

  static isAttachedToPrimary(item) {
    return item.PrimaryTpEvaluatorId !== null && item.PrimaryTpEvaluatorId !== undefined;
  }

  static displayedInList = 'EntityType';

  static NameOfTheIdField() {
    return 'TpEvaluatorId';
  }
  static nameOfTheItemDetailList() {
    return 'TpEvaluator Profiles';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = ['CreatedOnUtc', 'ModifiedOnUtc'];

  static BoolFields = [];

  static FieldsToShowInDataTable() {
    return [
      // {
      //   label: TpEvaluatorItem.getSelectedCellHeader,
      //   orderById: '',
      //   data: TpEvaluatorItem.getSelectedCellContent,
      //   type: FieldTypesEnum.PureDataField,
      //   minWidth: 10,
      // },
      {
        label: 'ID',
        orderById: 'TpEvaluatorId',
        data: 'TpEvaluatorId',
        minWidth: 50,
        type: FieldTypesEnum.DataFieldWithDetails,
      },
      {
        label: 'Name',
        orderById: 'Name',
        data: (item) => TpEvaluatorItem.GetFieldDependsOnDataProvider(item, 'Name'),
        minWidth: 50,
      },
      {
        label: 'Email',
        orderById: 'Email',
        data: (item) => TpEvaluatorItem.GetFieldDependsOnDataProvider(item, 'Email'),
        minWidth: 50,
      },
      {
        label: 'Country',
        data: 'Countries',
        minWidth: 50,
      },
      {
        label: 'Sources',
        data: 'ThirdPartySources',
        minWidth: 50,
      },
      {
        label: 'Status',
        data: 'Statuses',
        minWidth: 50,
      },
      {
        label: 'Links',
        data: TpEvaluatorItem.getLinksContent,
        minWidth: 50,
      },
      {
        label: ' ',
        data: TpEvaluatorItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-user',
      rolekey: 'Evaulator_tablisttable_EvaluatorGeneralView',
      data: [
        {
          name: 'TpEvaluatorId',
          label: 'ID',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: TpEvaluatorItem.GetInfoSourceText,
          // name: 'DataProviderInstance',
          label: 'Info Source',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => (
            <LongText
              text={item.ThirdPartySources}
              maxLength={20}
            />
          ),
          label: 'Sources',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: 'Name',
          label: 'Name',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => (
            <LongText
              text={item.Email}
              maxLength={20}
            />
          ),
          label: 'Email',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: 'Statuses',
          label: 'Status',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        { name: 'EvaluatorId', label: 'Evaluator ID', width: TabListTableCellWidthEnum.Single, className: 'text-left' },
        {
          name: 'EvaluatorSassieId',
          label: 'EvaluatorSassieId',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: 'NumberOfTpEvaluatorLinks',
          label: 'Linked profiles (count)',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: TpEvaluatorItem.getAttachedTpEvaluatorsText,
          label: 'Linked TP Evaluators',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => <DateComponent value={item.CreatedOnUtc} />,
          label: 'Created On',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => <DateComponent value={item.ModifiedOnUtc} />,
          label: 'Modified On',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },

        // fields for Tipalti
        {
          name: '-',
          label: 'Tipalti Data',
        },
        {
          name: 'TipaltiPayableStatus',
          label: 'Tipalti Payable Status',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: 'TipaltiAccountStatus',
          label: 'Tipalti Account Status',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: 'TipaltiPaymentMethod',
          label: 'Tipalti Payment Method',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: 'TipaltiPortalUser',
          label: 'Tipalti Portal User',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => <DateComponent value={item.LastTransferToTipalti} />,
          label: 'Last Transfer To Tipalti',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => <DateComponent value={item.TipaltiAttemptedPassOver} />,
          label: 'Tipalti Attempted Pass Over',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => <DateComponent value={item.TipaltiLastDataCheck} />,
          label: 'Tipalti Last Data Check',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: 'TipaltiError',
          label: 'Tipalti Error',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
      ],
    },
    {
      tabName: 'TpEvaluatorProfiles',
      tabLabel: 'Tp Evaluator Profiles',
      icon: 'fa-solid fa-users',
      rolekey: 'Evaulator_tablisttable_EvaluatorGeneralView',
      data: [
        {
          name: (item) => <TpEvaluatorLinkAdmin tpEvaluatorId={item.TpEvaluatorId} />,
          label: '',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
    {
      // CD-5527: the TP Evaluator profiles linked under this one (children never appear as rows of the main
      // list). Only meaningful on a primary/standalone row; the tab hides itself on a child row.
      tabName: 'LinkedTpEvaluators',
      tabLabel: 'Linked TP Evaluators',
      icon: 'fa-solid fa-link',
      rolekey: 'Evaulator_tablisttable_EvaluatorGeneralView',
      data: [
        {
          name: (item) =>
            TpEvaluatorItem.isAttachedToPrimary(item) ? null : (
              <LinkedTpEvaluatorsTab
                tpEvaluatorId={item.TpEvaluatorId}
                initialItem={item}
              />
            ),
          label: '',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
    {
      tabName: 'Comments',
      tabLabel: 'Comments',
      icon: 'fa-solid fa-comment',
      rolekey: 'Evaulator_tablisttable_EvaluatorGeneralView',
      data: [
        {
          name: (item) => (
            <GeneralEntryLogFigma
              description={CommentsEntryLogDescription}
              context={{ entityTypeId: 505, entityId: item.TpEvaluatorId }}
            />
          ),
          label: 'Comments',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
  ];

  static GetFieldDependsOnDataProvider(item, field) {
    if (item.DataProviderInstance === 'All') {
      return item[field];
    }
    return (
      <div>
        {item[field]}&nbsp;
        <FaIcon
          iconName='fa-regular fa-star-of-life'
          tooltipText={`Info source: ${item.DataProviderInstance}`}
          superScript={true}
        />
      </div>
    );
  }

  // "Links" cell: the merged link count, plus a link icon when other TP Evaluator profiles hang under this one.
  static getLinksContent(item) {
    if (!TpEvaluatorItem.hasAttachedTpEvaluators(item)) {
      return item.NumberOfTpEvaluatorLinks;
    }
    const ids = item.AttachedTpEvaluators.map((child) => `#${child.TpEvaluatorId}`).join(', ');
    return (
      <div>
        {item.NumberOfTpEvaluatorLinks}&nbsp;
        <FaIcon
          iconName='fa-solid fa-link'
          tooltipText={`Linked TP Evaluators: ${ids}`}
          superScript={true}
        />
      </div>
    );
  }

  static getAttachedTpEvaluatorsText(item) {
    if (!TpEvaluatorItem.hasAttachedTpEvaluators(item)) {
      return '-';
    }
    return item.AttachedTpEvaluators.map((child) => `#${child.TpEvaluatorId} ${child.Name}`).join('; ');
  }

  // One menu serves both grids: the main list (primaries/standalones, never carrying a PrimaryTpEvaluatorId)
  // and the "Linked TP Evaluators" tab (children, always carrying one) — only the children get "Detach from
  // primary". Linking itself is started from that tab. `hide` values are booleans on purpose —
  // DataTableActionMenu accepts them, and the vitest gate tests assert on them.
  static getActionsContent(item) {
    const isChild = TpEvaluatorItem.isAttachedToPrimary(item);
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-user-circle',
            roleKey: 'Evaulator_faicon_EvaluatorTipaltiProfileButton',
            text: 'Tipalti Profile',
            onClick: () => TpEvaluatorItem.tipaltiEditReviewFunction(item.EvaluatorId, item),
          },
          {
            iconName: 'fa-solid fa-list-check',
            roleKey: 'Evaulator_faicon_EvaluatorPaymentsButton',
            text: 'Jobs',
            onClick: () => TpEvaluatorItem.ListJobsFunction(item),
          },
          {
            iconName: 'fa-solid fa-clipboard-list',
            roleKey: 'Evaulator_faicon_AssignmentsButton',
            text: 'Evaluator Payments',
            onClick: () => TpEvaluatorItem.ListEvaluatorPaymentsFunction(item),
          },
          { separator: true, hide: !isChild },
          {
            iconName: 'fa-solid fa-link-slash',
            roleKey: 'Evaulator_faicon_PrimaryLinkButton',
            text: 'Detach from primary',
            onClick: () => TpEvaluatorItem.detachTpEvaluatorFunction(item),
            hide: !isChild,
            isMarkedRed: true,
          },
        ]}
      />
    );
  }

  static tipaltiEditReviewFunction = (id, user, userList) => {
    alert('TipaltiEditReview');
  };

  static ListJobsFunction(item) {
    return alert('Not implemented');
  }

  static ListEvaluatorPaymentsFunction(item) {
    return alert('Not implemented');
  }

  // Bound by LinkedTpEvaluatorsTab while it is mounted (child rows only render there).
  static detachTpEvaluatorFunction(item) {
    return alert('Not implemented');
  }

  // Bound by TpEvaluatorAdmin: called after a link/detach so the main list can refresh once the popup closes.
  static linkingChangedFunction() {}

  static GetInfoSourceText(item) {
    if (item.DataProviderInstance === 'All') {
      return 'Info at all sources : Match';
    }
    return `Info differs in the sources, we display the data from ${item.DataProviderInstance}`;
  }

  // static selectedStatus() {
  //   return false;
  // }

  // static getSelectedCellHeader(item) {
  //   return (
  //     <div>
  //       <input
  //         type='checkbox'
  //         checked={TpEvaluatorItem.selectedStatus()}
  //         onChange={(e) => {
  //           TpEvaluatorItem.clickOnGlobalSelect(item, e.target.checked);
  //         }}
  //       />
  //     </div>
  //   );
  // }
  // static clickOnGlobalSelect(item, selected) {}

  // static clickOnSelect(item, selected) {}

  // static getSelectedCellContent(item) {
  //   return (
  //     <div className='text-center'>
  //       <input
  //         type='checkbox'
  //         checked={item.Selected}
  //         onChange={(e) => {
  //           TpEvaluatorItem.clickOnSelect(item, e.target.checked);
  //         }}
  //       />
  //     </div>
  //   );
  // }
}
